import { useUser } from '@/@diffrag/providers/user.provider'
import { AdminRole, type AdminJwtUser } from '@/constants/adminRole'
import { Navigate } from 'react-router-dom'

type Props = {
  children: React.ReactNode
}

/** 슈퍼 관리자 전용 페이지 — 파트너 관리자는 실적 화면으로 리다이렉트 */
export function SuperAdminRoute({ children }: Props) {
  const user = useUser() as AdminJwtUser | undefined

  if (user?.role === AdminRole.PARTNER_ADMIN) {
    return <Navigate to="/referral-stats" replace />
  }

  return children
}
